




























import { Component, Vue, Prop } from "vue-property-decorator";
import { FileEntryModel } from "../models/fileEntry";
import dateFlip from "shared/filters/dateflip";

@Component({
  filters: { dateFlip },
})
export default class FileList extends Vue {
  @Prop({ required: true, type: Array }) value!: FileEntryModel[];
  @Prop({ required: false, type: Boolean, default: false }) tooltip!: boolean;
  @Prop({ required: true, type: String }) projectType!: string;

  public headers = [
    { text: this.t("category"), value: "category" },
    { text: this.t("description"), value: "description" },
    { text: this.t("archive_date"), value: "archive_date" },
    { text: "", value: "", sortable: false },
  ];

  public pagination = {
    descending: true,
    sortBy: "archive_date",
  };

  public t(key: string): string {
    return this.$t("projectsupload.tables.files." + key).toString();
  }

  private mounted() {
    (this.$refs.fileListTooltip as Element).parentElement!.className =
      "tooltip-container";
  }
}
